import "core-js/es/index";
import "core-js/es/symbol";
import "core-js/es/set";
import "core-js/es/map";
import "raf/polyfill";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import Store, { LanguageProvider } from "./core/store";
import { axiosConfig } from "./core/config/axios-config";

// sentryConfig();
axiosConfig();

ReactDOM.render(
    <Store>
        <LanguageProvider>
            <App />
        </LanguageProvider>
    </Store>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
